/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppropriationList,
  ErrorList,
} from '../models';
import {
    AppropriationListFromJSON,
    AppropriationListToJSON,
    ErrorListFromJSON,
    ErrorListToJSON,
} from '../models';

export interface GetUserAppropriationsRequest {
    baseSiteId: string;
    userId: string;
    cartId?: string;
    fields?: string;
    sapCommerceCloudCustomerId?: string;
}

/**
 * AppropriationsApi - interface
 * 
 * @export
 * @interface AppropriationsApiInterface
 */
export interface AppropriationsApiInterface {
    /**
     * Retrieves the customer\'s appropriations.
     * @summary Retrieves the customer\'s appropriations.
     * @param {string} baseSiteId Base site identifier
     * @param {string} userId User identifier or one of the literals : \&#39;current\&#39; for currently authenticated user, \&#39;anonymous\&#39; for anonymous user
     * @param {string} [cartId] Cart id
     * @param {string} [fields] Response configuration. This is the list of fields that should be returned in the response body. Examples: BASIC,DEFAULT,FULL
     * @param {string} [sapCommerceCloudCustomerId] Default B2B Unit of the B2B customer to be used during the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppropriationsApiInterface
     */
    getUserAppropriationsRaw(requestParameters: GetUserAppropriationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppropriationList>>;

    /**
     * Retrieves the customer\'s appropriations.
     * Retrieves the customer\'s appropriations.
     */
    getUserAppropriations(requestParameters: GetUserAppropriationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppropriationList>;

}

/**
 * 
 */
export class AppropriationsApi extends runtime.BaseAPI implements AppropriationsApiInterface {

    /**
     * Retrieves the customer\'s appropriations.
     * Retrieves the customer\'s appropriations.
     */
    async getUserAppropriationsRaw(requestParameters: GetUserAppropriationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppropriationList>> {
        if (requestParameters.baseSiteId === null || requestParameters.baseSiteId === undefined) {
            throw new runtime.RequiredError('baseSiteId','Required parameter requestParameters.baseSiteId was null or undefined when calling getUserAppropriations.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserAppropriations.');
        }

        const queryParameters: any = {};

        if (requestParameters.cartId !== undefined) {
            queryParameters['cartId'] = requestParameters.cartId;
        }

        if (requestParameters.fields !== undefined) {
            queryParameters['fields'] = requestParameters.fields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.sapCommerceCloudCustomerId !== undefined && requestParameters.sapCommerceCloudCustomerId !== null) {
            headerParameters['sap-commerce-cloud-customer-id'] = String(requestParameters.sapCommerceCloudCustomerId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_authorization_code", ["basic"]);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_client_credentials", ["extended"]);
        }

        const response = await this.request({
            path: `/{baseSiteId}/users/{userId}/appropriations`.replace(`{${"baseSiteId"}}`, encodeURIComponent(String(requestParameters.baseSiteId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppropriationListFromJSON(jsonValue));
    }

    /**
     * Retrieves the customer\'s appropriations.
     * Retrieves the customer\'s appropriations.
     */
    async getUserAppropriations(requestParameters: GetUserAppropriationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppropriationList> {
        const response = await this.getUserAppropriationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
